// Scrollablility goes from 0 to 1 as 0 is not scrollable at all to that side
// and 1 means you can still scroll all the way to that side. If you scroll 50%
// it will be 0.5
export const calculateScrollability = (
  element: HTMLElement,
  isRtl: boolean
): {
  amountScrollableToRight: number;
  amountScrollableToLeft: number;
} => {
  const scrollMultiplierByLangDirection = isRtl ? -1 : 1;
  const scrollableWidth = element.scrollWidth - element.clientWidth;
  if (scrollableWidth === 0) {
    return { amountScrollableToRight: 0, amountScrollableToLeft: 0 };
  }
  const keepBetweenZeroAndOne = (number: number) => Math.max(0, Math.min(1, number));
  const currentScrollPosition = element.scrollLeft * scrollMultiplierByLangDirection;
  const amountScrollableToRight = keepBetweenZeroAndOne(
    (scrollableWidth - currentScrollPosition) / scrollableWidth
  );

  const amountScrollableToLeft = keepBetweenZeroAndOne(currentScrollPosition / scrollableWidth);

  return { amountScrollableToRight, amountScrollableToLeft };
};
